import { useQuery } from "@apollo/client";

import { GET_MANAGED_USER_GROUP } from "./gql";

type useGetGroupProps = {
  id?: string;
};

const useGetGroup = ({ id }: useGetGroupProps) => {
  const { data, loading, error } = useQuery(GET_MANAGED_USER_GROUP, {
    variables: {
      id: id!,
    },
    skip: !id,
  });

  return { group: data?.managedUserGroup, loading, error };
};

export default useGetGroup;
